import { ImagingOrderStatus } from '~/constants/imaging'

export const isCompletedImagingStatus = (actualStatusName: string) =>
  actualStatusName === ImagingOrderStatus.COMPLETED ||
  actualStatusName === ImagingOrderStatus.IMAGE_RECEIVED
